<template>
    <div v-if="pathTools.inNt2Pijler()" class="absolute -mt-1.5 sm:mt-0 sm:relative" >
        <h2 class="text-xl ml-6 mb-1 mt-4 text-azuur font-bold sm:text-lg">AANBOD NT2 | DUTCH</h2>
        <div class="flex ml-6 leading-normal">
            <IconChevronRight  class="h-4 w-4 mr-1 mt-1.5 sm:w-8 sm:mt-0.5" />
            <div>
                Hieronder zie je ons volledig aanbod voor NT2. Je kan het aanbod voor alle&nbsp;
                <NuxtLink to="/cursus-opleiding" class="text-indigo font-semibold text-lg">cursussen | opleidingen</NuxtLink>
                &nbsp;bekijken of het aanbod doorzoeken via de&nbsp;
                <NuxtLink to="/studiewijzer" class="text-teal font-semibold text-lg">studiewijzer</NuxtLink>.
            </div>
        </div>
        <div class="flex flex-wrap mt-1">
            <div class="w-75 ml-6">
                <ul>
                    <h3 class="text-sm font-bold text-grey-light mt-3 mb-1">
                        Aanbod per categorie
                    </h3>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" ><NavLink to="/nt2/standaard">Standaard</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" ><NavLink to="/nt2/verlengd">Verlengd</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" ><NavLink to="/nt2/verkort">Verkort</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" ><NavLink to="/nt2/e-learning">E-learning</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" ><NavLink to="/nt2/speciaal-aanbod-nederlands">Speciaal aanbod Nederlands</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" ><NavLink to="/nt2/participatie-ik-doe-mee">Participatie trajecten</NavLink></li>
                </ul>
            </div>
            <div class="w-75 ml-6">
                <ul>
                    <h3 class="text-sm font-bold text-grey-light mt-3 mb-1">
                        Aanbod per niveau
                    </h3>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-11-a1">1.1</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-11-a1/11-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-11-a1/11-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-11-a1/11-verkort">Verkort</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-11-a1/11-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-12-a2">1.2</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-12-a2/12-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-12-a2/12-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-12-a2/12-verkort">Verkort</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-12-a2/12-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-21-b1">2.1</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-21-b1/21-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-21-b1/21-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-21-b1/21-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-22-b1">2.2</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-22-b1/22-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-22-b1/22-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-22-b1/22-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-23-b1">2.3</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-23-b1/23-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-23-b1/23-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-23-b1/23-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-24-b1">2.4</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-24-b1/24-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-24-b1/24-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-24-b1/24-e-learning">E-learning</NavLink>
                    </li>
                </ul>
            </div>
            <div class="w-75 ml-6">
                <ul>
                    <h3 class="text-sm font-bold text-white mt-3 mb-1">
                        Aanbod per niveau
                    </h3>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-31-b2">3.1</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-31-b2/31-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-31-b2/31-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-31-b2/31-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-32-b2">3.2</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-32-b2/32-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-32-b2/32-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-32-b2/32-verkort">Verkort</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-32-b2/32-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-41-c1">4.1</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-41-c1/41-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-41-c1/41-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-41-c1/41-e-learning">E-learning</NavLink>
                    </li>
                    <li class="pb-1 text-grey-light  flex items-start" >
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-42-c1">4.2</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-42-c1/42-standaard">Standaard</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-42-c1/42-verlengd">Verlengd</NavLink>&nbsp;|&nbsp;
                        <NavLink class="hover:text-grey-dark" to="/nt2/niveau-42-c1/42-e-learning">E-learning</NavLink>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div v-else-if='pathTools.inStudiewijzerPijler()' class="absolute -mt-1.5 sm:mt-0 sm:relative" >
        <h2 class="text-xl ml-6 mb-1 mt-4 text-teal font-bold sm:text-lg">AANBOD VIA STUDIEWIJZER</h2>
        <div class="flex ml-6 leading-normal">
            <IconChevronRight  class="h-4 w-4 mr-1 mt-1.5 sm:w-8 sm:mt-0.5" />
            <div>
                Hieronder zie je ons volledig aanbod via de studiewijzer. 
                Je kan ook het aanbod voor alle&nbsp;<NuxtLink to="/cursus-opleiding" class="text-indigo font-semibold  text-lg">
                cursussen | opleidingen</NuxtLink>&nbsp;bekijken of enkel het aanbod&nbsp;
                <NuxtLink to="/nt2" class="text-azuur font-semibold text-lg">NT2 | Dutch</NuxtLink>.
            </div>
        </div>
        <div class="flex flex-wrap mt-4">
            <div class="w-full ml-6">
                <ul>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/tweedekansonderwijs">Diploma secundair onderwijs (tweedekansonderwijs)</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/nt2/specifieke-trajecten/toekan-1">Diploma en meer Nederlands leren (TOeKan)</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/tako">Traject met alternatieve kansen op onderwijs (TaKO)</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/hoger-onderwijs">Voorbereiding hogere studies</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/bij-of-omscholen">Bij- of omscholen</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/cursus-opleiding/ict/digisprong">Digisprong</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/aanbod-per-regio">Aanbod per regio</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/online-aanbod">100% online aanbod</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/vdab">VDAB-traject naar werk</NavLink></li>
                    <li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/evc">EVC-beroepskwalificatie</NavLink></li>
                    
                    <!--<li class="pb-1 text-grey-light hover:text-grey-dark flex items-start" >
                        <NavLink to="/studiewijzer/duaal-leren">duaal leren</NavLink></li>-->
                    
                </ul>
            </div>
        </div>
    </div>

    <div v-else class="absolute -mt-1.5 sm:mt-0 sm:relative" >
        <h2 class="text-xl ml-6 mb-1 mt-4 text-indigo font-bold sm:text-lg">AANBOD CURSUS | OPLEIDING</h2>
        <div class="flex ml-6 leading-normal">
            <IconChevronRight  class="h-4 w-4 mr-1 mt-1.5 sm:w-8 sm:mt-0.5" />
            <div>
                Hieronder zie je ons volledig aanbod per interessegebied. 
                Je kan het aanbod ook bekijken via de&nbsp;<NuxtLink to="/studiewijzer" class="text-teal font-semibold text-lg">
                studiewijzer</NuxtLink>&nbsp;of enkel voor&nbsp;<NuxtLink to="/nt2" class="text-azuur font-semibold text-lg">
                NT2 | Dutch</NuxtLink>.
            </div>
        </div>
        <div class="flex flex-wrap mt-1">
            <MmCategory v-for="category in publiekeTopCategories" :key="category.id" :category="category" />
        </div>
    </div>
</template>

<script setup>
    const categoryTools = useCategoryTools();
    const categoryStore = useCategoryStore();
    const pathTools = usePathTools();

    const publiekeTopCategories = computed(() => categoryTools.publicCategories(categoryStore.topCategories));
</script>
